import classNames from 'classnames';
import styles from './Anchor.module.scss';

export interface AnchorProps {
	className?: string;
	anchorId?: string;
}

export const UI_Anchor = ({ className, anchorId }: AnchorProps) => {
	return (
		<div className={classNames(styles.Anchor, className)}>
			<div className={styles.Anchor_id} id={anchorId} />
		</div>
	);
};
